
import { Component, Vue, Prop } from 'vue-property-decorator';
import PageBase from "../PageBase.vue";
import LegalAssistanceFaq from "@/components/utils/LegalAssistanceFaq.vue";

import {resetProgressOfAllPages} from '@/components/utils/StepsAndPages/StepAndPageFunctions'
import {stepInfoType, stepResultInfoType } from "@/types/Application";
import { toggleStep, togglePages } from '@/components/utils/TogglePages';
import {resetAllPathwaysCompeleted} from '@/components/utils/Pathways/PathwayFunctions'

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

import Tooltip from "@/components/survey/Tooltip.vue";

@Component({
    components:{
        PageBase,
        Tooltip,
        LegalAssistanceFaq
    }
})
export default class GettingStarted extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.State
    public steps!: stepInfoType[];

    @applicationState.State
    public types!: string[]

    @applicationState.State
    public rejectedPathway!: boolean;

    @applicationState.Action
    public UpdateApplicationType!: (newApplicationType: string[]) => void

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void
  
    selected = [];
    selectedReplyForms = [];
    returningUser = false
    showLegalAssistance = false;    

    currentStep =0;
    currentPage =0;
    dataReady = false;

    mounted(){ 
        this.dataReady = false;        
        this.reloadPageInformation();
    }

    public reloadPageInformation(){               
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;

        const includesOrderActivities = this.steps[this.stPgNo.GETSTART._StepNo].result?.selectedActivity.includes('applyForOrder');
        const includesReplyActivities = this.steps[this.stPgNo.GETSTART._StepNo].result?.selectedActivity.includes('replyToApplication');       

        if (includesReplyActivities && this.steps[this.stPgNo.GETSTART._StepNo].result?.selectedReplyForms) {
            this.selectedReplyForms = this.steps[this.stPgNo.GETSTART._StepNo].result.selectedReplyForms;
        }

        if (includesOrderActivities && this.steps[this.stPgNo.GETSTART._StepNo].result?.selectedForms) {
            this.selected = this.steps[this.stPgNo.GETSTART._StepNo].result.selectedForms;
            if (this.selectedReplyForms.includes("replyFlm")){
                const index = this.selected.indexOf('familyLawMatter');
                if (index != -1){
                    this.selected.splice(index, 1);
                }
            }
        }
        
        this.returningUser = (this.$store.state.Application.userType == 'returning');        

        const progress = this.selected.length==0? 50 : 100;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
        
        this.onChange(this.selected)
        
        this.dataReady = true;
    }
  
    public onChange(selectedForms) {
        
        const applicationTypes = [];       
        
        if (this.steps[this.stPgNo.GETSTART._StepNo].result?.selectedActivity?.includes('replyToApplication') 
                && this.steps[this.stPgNo.GETSTART._StepNo].result?.selectedReplyApplications){
            for (const replyForm of this.steps[this.stPgNo.GETSTART._StepNo].result?.selectedReplyApplications){                    
                applicationTypes.push(Vue.filter('getFullOrderName')(replyForm, ''));
            }
        } 

        for (const form of selectedForms){                    
            applicationTypes.push(this.getApplicationType(form));
        }
      
        this.UpdateApplicationType(Array.from(new Set(applicationTypes)));        
        this.setSteps(selectedForms);
        resetAllPathwaysCompeleted();
        resetProgressOfAllPages(selectedForms, [this.stPgNo.GETSTART._StepNo]);
    }

    public getApplicationType(selectedOrder){
        const step = this.steps[this.stPgNo.PO._StepNo]
        let orgFPOType = ''
        if (selectedOrder == 'protectionOrder' && step.result?.poQuestionnaireSurvey?.data?.orderType){
            orgFPOType = step.result.poQuestionnaireSurvey.data.orderType;
        } 

        return Vue.filter('getFullOrderName')(selectedOrder, orgFPOType);
    }

    public setSteps(selectedForms) {
        
       if (selectedForms !== undefined && this.selectedReplyForms !== undefined) {            
    
            const poOnly = (selectedForms.length == 1 && selectedForms.includes("protectionOrder"));
            const poIncluded = selectedForms.includes("protectionOrder"); 

            const wrIncluded = this.selectedReplyForms.includes("writtenResponse");
            const rflmIncluded = this.selectedReplyForms.includes("replyFlm");

            const flmIncluded = !rflmIncluded && selectedForms.includes("familyLawMatter");
            const cmIncluded = selectedForms.includes("caseMgmt");
            const ppmIncluded = selectedForms.includes("priorityParenting");
            const crIncluded = selectedForms.includes("childReloc");
            const aeIncluded = selectedForms.includes("agreementEnfrc");

            toggleStep(this.stPgNo.PO._StepNo,    poIncluded);
            toggleStep(this.stPgNo.FLM._StepNo,   flmIncluded);
            toggleStep(this.stPgNo.CM._StepNo,    cmIncluded);
            toggleStep(this.stPgNo.PPM._StepNo,   ppmIncluded);
            toggleStep(this.stPgNo.CONNECT._StepNo, false);
            toggleStep(this.stPgNo.RELOC._StepNo, crIncluded);
            toggleStep(this.stPgNo.ENFRC._StepNo, aeIncluded);

            toggleStep(this.stPgNo.SUBMIT._StepNo, (selectedForms.length>0 || wrIncluded || rflmIncluded));//Review And Submit
            
            toggleStep(this.stPgNo.COMMON._StepNo, wrIncluded || rflmIncluded || flmIncluded || ppmIncluded || crIncluded || cmIncluded || aeIncluded);//Common Your Information
            togglePages([this.stPgNo.COMMON.SafetyCheck], !poIncluded, this.stPgNo.COMMON._StepNo);//Safety Check
            togglePages([this.stPgNo.COMMON.Notice], ppmIncluded, this.stPgNo.COMMON._StepNo);//Notice
            togglePages([this.stPgNo.GETSTART.FlmInfo], flmIncluded, this.stPgNo.GETSTART._StepNo);//Flm Info
            
            this.$store.commit("Application/setCurrentStepPage", {currentStep: this.stPgNo.COMMON._StepNo, currentPage: (poIncluded? this.stPgNo.COMMON.YourInformation:this.stPgNo.COMMON.SafetyCheck) });//correct Safety Check page in sidebar
            togglePages([this.stPgNo.COMMON.YourInformation, this.stPgNo.COMMON.OtherPartyCommon, this.stPgNo.COMMON.FilingLocation], (selectedForms.length>0 && !poOnly) || wrIncluded || rflmIncluded, this.stPgNo.COMMON._StepNo);//Your Information, Other Party, Filing Location    
        }
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage();
    }    

    public onNext() { 
        Vue.prototype.$UpdateGotoNextStepPage();
    }    
  
    beforeDestroy() {
        const progress = this.selected.length==0? 50 : 100;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);
        this.UpdateStepResultData({step:this.step, data: {selectedForms: this.selected}})
    }
}
